import { render, staticRenderFns } from "./palletCommercial.vue?vue&type=template&id=02510751&scoped=true"
import script from "./palletCommercial.vue?vue&type=script&lang=js"
export * from "./palletCommercial.vue?vue&type=script&lang=js"
import style0 from "./palletCommercial.vue?vue&type=style&index=0&id=02510751&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02510751",
  null
  
)

export default component.exports